module.exports = __webpack_public_path__ + "static/media/food-closet-volunteers.db4f70b5.jpg";